module.exports = __webpack_public_path__ + "static/media/confirm-company.0bb63495.svg";